import { render, staticRenderFns } from "./merchant-drug.vue?vue&type=template&id=af9db096&scoped=true"
import script from "./merchant-drug.vue?vue&type=script&lang=js"
export * from "./merchant-drug.vue?vue&type=script&lang=js"
import style0 from "./merchant-drug.vue?vue&type=style&index=0&id=af9db096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9db096",
  null
  
)

export default component.exports